"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _breakpointObserver = require("@decisiv/breakpoint-observer");

var _SortableHeaderCell = _interopRequireDefault(require("./SortableHeaderCell"));

var _Provider = require("../Provider");

var _joinClassnames = _interopRequireDefault(require("../../../utils/joinClassnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function isSortableHeader(config) {
  if ('sortBy' in config && 'title' in config) {
    return true;
  }

  return false;
}

function CellRenderer(_ref) {
  var CustomHeaderCell = _ref.CustomHeaderCell,
      rest = _objectWithoutProperties(_ref, ["CustomHeaderCell"]);

  if (CustomHeaderCell) return _react.default.createElement(CustomHeaderCell, rest);
  if (isSortableHeader(rest)) return _react.default.createElement(_SortableHeaderCell.default, rest);
  var title = rest.title;
  return _react.default.createElement("span", null, title);
}

function HeaderCell(props) {
  var name = props.name,
      fixed = props.fixed,
      getHeaderCellAttrs = props.getHeaderCellAttrs;

  var _useContext = (0, _react.useContext)(_Provider.TableContext),
      onColumnResize = _useContext.onColumnResize,
      fixedColumns = _useContext.fixedColumns,
      isDragging = _useContext.isDragging;

  var _useBreakpointObserve = (0, _breakpointObserver.useBreakpointObserver)(),
      _useBreakpointObserve2 = _slicedToArray(_useBreakpointObserve, 2),
      ref = _useBreakpointObserve2[0],
      dimensions = _useBreakpointObserve2[1].dimensions;

  (0, _react.useEffect)(function () {
    (!isDragging || fixed) && onColumnResize && onColumnResize(name, dimensions.width || 0);
  }, [onColumnResize, dimensions, fixed, name, isDragging]);
  var fixedColumn = fixedColumns[name];
  var customAttrs = getHeaderCellAttrs && getHeaderCellAttrs(name) || {};
  return _react.default.createElement("th", {
    ref: ref,
    id: name,
    scope: "col",
    className: (0, _joinClassnames.default)(fixedColumn && fixedColumn.alignment, customAttrs.className),
    style: _objectSpread({}, fixedColumn ? _defineProperty({}, fixedColumn.alignment, fixedColumn.offset) : {}, {}, customAttrs.style || {})
  }, _react.default.createElement("div", null, _react.default.createElement(CellRenderer, props)));
}

var _default = HeaderCell;
exports.default = _default;